module.exports = __webpack_public_path__ + "img/BTC.744fe687.svg";